export default __webpack_public_path__ + "static/media/cadeaux-5.4c6e1b28.jpeg";